import React from 'react';
import {
  Text,
} from 'react-native';
import {
  Android,
  enter_amount_title,
  Or_enter_other_amount,
} from '../../../../../utils/DictionaryManagementUtils';
import FullPageSimulator from '../../FullPageSimulator';
import TableFourSquares from '../../../AuxiliaryComponent/MixComponent/TableFourSquares';
import AccountBalance from '../../../AuxiliaryComponent/AmountSim/AccountBalance';
import { textLink_9_3 } from '../../../AuxiliaryComponent/TextComponent/TextStyle';

//= ========================================================================

const EnterAmountMenuFP = ({
  globJSON, simPlatform, subCategoryId,
}) => {
  const myStyles = {
    textLinkStyle: {
      textAlign: 'center',
      marginTop: simPlatform === Android ? '30%' : '15%',
    },
  };
  return (
    <FullPageSimulator
      globJSON={globJSON}
      simPlatform={simPlatform}
      headlineText={enter_amount_title}
    >
      <AccountBalance
        globJSON={globJSON}
        showExpendBox
      />
      <TableFourSquares
        globJSON={globJSON}
        subCategoryId={subCategoryId}
      />
      <Text style={[textLink_9_3(globJSON, simPlatform), myStyles.textLinkStyle]}>{Or_enter_other_amount}</Text>
    </FullPageSimulator>
  );
};
export default EnterAmountMenuFP;
